var Vue = require('vue').default


window.Swiper = require('./swiper.min.js')
require('../../vcomps/init_js/scale')
var alter_fn = require('./modules/alter/alter')
var top_box_fn = require('./modules/top_box/top_box')
alter_fn()
top_box_fn()
// //-------------- 兼容模式引用start----------------
// require('core-js/fn/object/assign');
// require('core-js/fn/array/fill');
// //-------------- 兼容模式引用end------------------


function cookie_to_json() {

    var cookie_text = document.cookie;
    var arr = [];
    var text_to_split = cookie_text.split(";");
    for (var i in text_to_split) {
        var tmp = text_to_split[i].split("=");
        arr.push('"' + tmp.shift().trim() + '":"' + tmp.join(":").trim().replace(/"/g, "\\\"") + '"')
    }
    ;
    var res = '{\n' + arr.join(",\n") + '\n}';

    return JSON.parse(res);
}

var cookie_json = cookie_to_json()

var params = new URLSearchParams(window.location.search)

Vue.prototype.$httpr = require('./modules/api')
Vue.prototype.conf_name = {
    0 : '特工角色(洞明)',
    1 : '特工角色(英格丽特)',
    2 : '特工角色(甘霖)',
    3 : '特工角色(沉礁)',
    4 : '特工角色(天星)',
    5 : '特工角色(弥砂)',
    6 : '特工角色(铣刀)',
    7 : '宝塔奇兵打印箱',
    8 : '电音浪客打印箱',
    9 : '毛球怪打印箱',
    10: '恶灵公馆打印箱',
    11: '皇牌足球打印箱',
    12: '舞艺超群打印箱',
    13: '坦克连打印箱',
}
Vue.prototype.lotter_conf_name = {
    0 : '洞明',
    1 : '英格丽特',
    2 : '甘霖',
    3 : '沉礁',
    4 : '天星',
    5 : '弥砂',
    6 : '铣刀',
    7 : '宝塔奇兵打印箱',
    8 : '电音浪客打印箱',
    9 : '毛球怪打印箱',
    10: '恶灵公馆打印箱',
    11: '皇牌足球打印箱',
    12: '舞艺超群打印箱',
    13: '坦克连打印箱',
}
console.log('params.get(\'shave_tel\')',params.get('shave_tel'))
Vue.prototype.user_data = {
    account       : cookie_json.a_tel || '',
    shave_tel     : params.get('shave_tel') || '',
    a_tel_shave   : cookie_json.a_tel_shave || '',
    value         : 0,
    config_is_lock: false,
}


new Vue({render: h => h(require('./App'))}).$mount("#app")